import React from "react";
import { isValidDate, orderStatus, orderStatusPercentage, russianMonth } from "../../../util";

function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

function truncate(str, num) {
    if (str.length <= num) {
        return str;
    } else {
        str = str.slice(0, num);
        return str + "...";
    }
}

const Card = ({ onClick, order, IsSelected, text_gray, statuses, text_dark, text_white, Nactive_bg, active_bg, title, ID, status_title, data, status_dots, status_bar, status_bar_Nactive, status_bar_fill, dark_point, white_point, trans_point, dots_bar, gray_bar, white_bar, empty_time }) => {
    const { statuses: statusList, done: orderDone } = statuses;

    const percentageDone = orderStatusPercentage(order);

    const dotImage = IsSelected ? white_point : dark_point;
    const dotBarImage = IsSelected ? white_bar : gray_bar;

    let status_text;
    let status_bg;

    switch (orderStatus(order)) {
        case "in_progress":
            status_bg = data.LkDelivery.DeliveryStatuses.process.bgColor;
            status_text = data.LkDelivery.DeliveryStatuses.process.color;
            break;
        case "done":
            status_bg = data.LkDelivery.DeliveryStatuses.completed.bgColor;
            status_text = data.LkDelivery.DeliveryStatuses.completed.color;
            break;
        case "aborted":
            status_bg = data.LkDelivery.DeliveryStatuses.сancelled.bgColor;
            status_text = data.LkDelivery.DeliveryStatuses.сancelled.color;
            break;
    }

    return (
        <div
            onClick={onClick}
            style={{ color: text_gray, backgroundColor: IsSelected ? active_bg : Nactive_bg }}
            className="px-6 py-5 pb-7 h-fit w-full flex flex-col items-center justify-between rounded-[20px]"
        >
            <div className="top w-full flex flex-row justify-between items-center ">
                <div className="">
                    <span className="mr-1">{title}</span>
                    <span style={{ color: IsSelected ? text_white : text_dark }}>{truncate(ID, 8)}</span>
                </div>
                <div className="flex flex-row">
                    <span style={{ color: status_text, backgroundColor: status_bg }} className="px-4 py-2 mr-3 rounded-full whitespace-nowrap text-[14px]">{status_title}</span>
                    <button><img src={status_dots} alt=":" /></button>
                </div>
            </div>
            <div style={{ backgroundColor: IsSelected ? status_bar : status_bar_Nactive }} className="mid w-full h-[8px] mt-5 mb-5 rounded-[12px]">
                <div style={{ backgroundColor: status_bar_fill, width: `${percentageDone}%`}} className={`h-[8px] rounded-[12px]`}></div>
            </div>
            <div className="bot flex flex-row justify-start gap-4 h-[100px] w-full">
                <div className="flex flex-col justify-between w-fit h-full text-[14px]">
                    {
                        statusList.map((s, _) => {
                            try {
                                return (
                                    <span>{s.date.getDate()} {russianMonth[s.date.getMonth() + 1].slice(0, 3)}.</span>
                                )
                            } catch (e) {
                                return (
                                    <span>-/-</span>
                                )
                            }
                        })
                    }
                </div>
                <div className="flex flex-col pt-[2px] w-fit h-full">
                    <img
                        src={dotImage}
                        alt="status-point"
                    />
                    <img
                        src={dotBarImage}
                        alt="dots-bar"
                        className="h-[32px]"
                    />
                    <img
                        src={dotImage}
                        alt="status-point"
                    />
                    <img
                        src={orderDone ? dotBarImage : dots_bar}
                        alt="dots-bar"
                        className="h-[35px] -mb-[2px] items-center"
                    />
                    <img
                        src={orderDone ? dotImage : trans_point}
                        alt="status-point"
                    />
                </div>
                <div className="flex flex-col justify-between w-fit h-full text-[14px]">
                    {statusList.map((s, _) => (
                        <>
                            <span className="lg:block hidden" style={{ color: IsSelected ? text_white : text_dark }}>{capitalizeFirstLetter(truncate(s.name, 30))}</span>
                            <span className="block lg:hidden" style={{ color: IsSelected ? text_white : text_dark }}>{capitalizeFirstLetter(truncate(s.name, 10))}</span>
                        </>
                    ))}
                </div>
                <div className="flex flex-col justify-between w-fit h-full ml-auto text-end text-[14px]">
                    <span style={{ color: IsSelected ? text_white : text_dark }}>{statusList[0].date.toLocaleTimeString('ru-RU', { hour12: false }).slice(0, 5)}</span>
                    <span style={{ color: IsSelected ? text_white : text_dark }}>{isValidDate(statusList[1].date) ? statusList[1].date.toLocaleTimeString('ru-RU', { hour12: false }).slice(0, 5) : empty_time}</span>
                    <span style={{ color: IsSelected ? text_white : text_dark }}>{orderDone ? statusList[2].date.toLocaleTimeString('ru-RU', { hour12: false }).slice(0, 5) : empty_time}</span>
                </div>
            </div>

        </div>
    );
};

export default Card;
